import { ChevronLeft, ChevronRight } from "lucide-react";

const range = (page, pages) => {
  if (pages <= 7) return Array.from({ length: pages }, (_, i) => i + 1);
  const set = [1, pages, page - 1, page, page + 1].filter((p) => p >= 1 && p <= pages);
  const sorted = [...new Set(set)].sort((a, b) => a - b);
  return sorted.flatMap((p, i) => (i && p - sorted[i - 1] > 1 ? ["…", p] : [p]));
};

const btn = "flex h-11 min-w-11 items-center justify-center rounded-full px-3 text-sm font-semibold transition-colors duration-300";

export const Pager = ({ page, pages, onChange }) => {
  if (pages <= 1) return null;
  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" data-testid="gallery-pagination" aria-label="Gallery pages">
      <button disabled={page <= 1} onClick={() => onChange(page - 1)} className={`${btn} border border-[#D4AF37]/30 text-[#F3E5AB] disabled:opacity-30`} data-testid="pagination-prev" aria-label="Previous page">
        <ChevronLeft size={18} />
      </button>
      {range(page, pages).map((p, i) =>
        p === "…" ? (
          <span key={`e${i}`} className="px-1 text-[#E8D8C8]">…</span>
        ) : (
          <button key={p} onClick={() => onChange(p)} className={`${btn} ${p === page ? "bg-gold-foil text-[#240620]" : "border border-[#D4AF37]/30 text-[#FFF8EF] hover:border-[#D4AF37]"}`} data-testid={`pagination-page-${p}`} aria-current={p === page ? "page" : undefined}>
            {p}
          </button>
        ),
      )}
      <button disabled={page >= pages} onClick={() => onChange(page + 1)} className={`${btn} border border-[#D4AF37]/30 text-[#F3E5AB] disabled:opacity-30`} data-testid="pagination-next" aria-label="Next page">
        <ChevronRight size={18} />
      </button>
    </nav>
  );
};
